export default {
  'clientInfo.add': 'Add banner',
  'clientInfo.bannerTitle': 'Title',
  'clientInfo.enterBannerTitle': 'Please enter title',
  'clientInfo.bannerTitleMaxLength': 'Title length cannot exceed 50 characters',
  'clientInfo.displayTarget': 'Visible User Groups',
  'clientInfo.allUsers': 'All Users',
  'clientInfo.allUsersOneClick': 'All Users',
  'clientInfo.advancedSettings': 'Advanced Settings (Optional)',
  'clientInfo.liveStreamTag': 'Live Stream',
  'clientInfo.unloggedUser': 'Unlogged Users (Visitors)',
  'clientInfo.noDepositUser': 'No-deposit Users',
  'clientInfo.noDepositUserTip': 'No-deposit Users targets logged-in players without a first deposit; it cannot be combined with VIP Levels or Unlogged Users',
  'clientInfo.vipLevelGroup': 'VIP Levels',
  'clientInfo.client': 'Client',
  'clientInfo.langName': 'Language',
  'clientInfo.forwardCode': 'Forward Code',
  'clientInfo.indexSpopupType': 'Home page popup type',
  'clientInfo.currency': 'Currency',
  'clientInfo.selectCurrency': 'Please select currency',
  'clientInfo.imageType': 'Display Position',
  'clientInfo.selectImageType': 'Please select display position',
  'clientInfo.selectDisplayTarget': 'Please select display target',
  'clientInfo.liveUrl': 'Live Stream URL',
  'clientInfo.enterLiveUrl': 'Please enter live stream URL',
  'clientInfo.liveUrlMaxLength': 'Live stream URL cannot exceed 500 characters',
  'clientInfo.liveColumn': 'Live',
  'clientInfo.selectLiveFilter': 'Please select',
  'clientInfo.hasLiveUrl': 'Has Live Stream',
  'clientInfo.noLiveUrl': 'No Live Stream',
  'clientInfo.indexBannerImage': 'Homepage Banner',
  'clientInfo.discountBannerImage': 'Discount Banner',
  'clientInfo.thirdPartyLoginAd': 'First Third-Party Login Page Ad',
  'clientInfo.kioskBannerImage': 'Kiosk Banner',
  'clientInfo.checkinActivityBannerImage': 'Check-in & Active Activity Banner',
  'clientInfo.treasureBoxActivityBannerImage': 'Treasure Box Activity Banner',
  'clientInfo.loginBannerImage': 'Login Page Banner',
  'clientInfo.registerBannerImage': 'Register Page Banner',
  'clientInfo.startupBannerImage': 'Startup Page Banner',
  'clientInfo.language': 'Language',
  'clientInfo.selectLanguage': 'Please select language',
  'clientInfo.enterMenuOrder': 'Please enter menu order',
  'clientInfo.enterMenuLink': 'Please enter menu link',
  'clientInfo.redirectLink': 'Redirect Link/Code',
  'clientInfo.enterRedirectLink': 'Please enter redirect link/code',
  'clientInfo.uploadImage': 'Please upload image',
  'clientInfo.pc': 'PC',
  'clientInfo.h5': 'H5',
  'clientInfo.app': 'APP',
  'clientInfo.kiosk': 'Kiosk',
  'clientInfo.topImage': 'Top Image',
  'clientInfo.discountEntranceImage': 'Discount Entrance Image',
  'clientInfo.logoImage': 'Logo Image',
  'clientInfo.pendantImage': 'Pendant Image',
  'clientInfo.imageName': 'Image Name',
  'clientInfo.enterImageName': 'Please enter image name',
  'clientInfo.popupType': 'Homepage Popup Type',
  'clientInfo.selectPopupType': 'Please select popup type',
  'clientInfo.loginBefore': 'Before Login',
  'clientInfo.loginAfter': 'After Login',
  'clientInfo.registerSuccess': 'Register Success',
  'clientInfo.firstDepositDetainment': 'First Deposit Retention',
  'clientInfo.addSuccess': 'Add Success',
  'clientInfo.addFailed': 'Add Failed',
  'clientInfo.editSuccess': 'Edit Success',
  'clientInfo.editFailed': 'Edit Failed',
  'clientInfo.missingRedirectLink': 'Redirect link/code not entered',
  'clientInfo.pcImageUpload': 'PC Image Upload',
  'clientInfo.h5ImageUpload': 'H5 Image Upload',
  'clientInfo.appImageUpload': 'APP Image Upload',
  'clientInfo.kioskImageUpload': 'Kiosk Image Upload',
  'clientInfo.formValidationFailed': 'Form validation failed',
  'clientInfo.pcImage': 'PC Image',
  'clientInfo.h5Image': 'H5 Image',
  'clientInfo.appImage': 'APP Image',
  'clientInfo.kioskImage': 'Kiosk Image',
  'clientInfo.noImage': 'No Image',
  'clientInfo.dataLoadFailed': 'Data load failed',
  'clientInfo.activityHomeImage': 'Activity Homepage',
  'clientInfo.contactMethod': 'Contact Method',
  'clientInfo.enterContactMethod': 'Please enter contact method',
  'clientInfo.enterSort': 'Please enter sort order',
  'clientInfo.redirectLinkCode': 'Redirect Link/Code',
  'clientInfo.enterRedirectLinkCode': 'Please enter redirect link/code',
  'clientInfo.iconUpload': 'Icon Upload',
  'clientInfo.refreshMenuCache': 'Refresh Menu Cache',
  'clientInfo.menuName': 'Menu Name',
  'clientInfo.enterMenuName': 'Please enter menu name',
  'clientInfo.menuIcon': 'Menu Icon',
  'clientInfo.navName': 'Navigation Name',
  'clientInfo.enterNavName': 'Please enter navigation name',
  'indexLtMenu.menuIcon': 'Menu Icon',
  'indexBotMenu.menuName': 'Menu Name',
  'indexBotMenu.enterMenuName': 'Please enter navigation name',
  'indexBotMenu.menuIcon': 'Menu Icon',
  'indexBotMenu.menuOrder': 'Menu Order',
  'indexBotMenu.menuLink': 'Menu Link',
  'indexBotMenu.h5Icon': 'H5 Icon',
  'indexBotMenu.pcIcon': 'PC Icon',
  'indexBotMenu.isEnable': 'Enable',
  'indexBotMenu.isMain': 'Is Main Menu',
  'clientInfo.imageTitle': 'Image Title',
  'clientInfo.enterImageTitle': 'Please enter image title',
  'clientInfo.status': 'Status',
  'clientInfo.selectStatus': 'Please select status'
}
